import { Site, userRole } from 'constant';
import { Layout, LayoutProps } from 'containers';
import {
  getLockStatus,
  getStatusKy,
  getKYDataApproveGroupBySiteManage,
} from 'containers/Layout/thunk';
import { useAppDispatch } from 'hooks';
import { dayjs } from 'libs';
import { routes } from 'navigations/routers';
import AlbumsCm from 'pages/Home/Cm/Albums';
import Albums from 'pages/Home/Dtc/Albums';
import WorkerInfoSite from 'pages/Home/Dtc/WorkerInfoSite';
import { userData } from 'pages/Login/selectors';
import { FC, useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import { businessDetailSelector } from '../Home/Bo/BusinessDetail/selectors';
import { getSiteGroupsWorkers } from '../Home/Bo/BusinessDetail/thunk';
import { imageSelectors, siteDetailSelector } from './selectors';
import SectionStyled from './styles';
import { getAlbumsImage, getDetailImage } from './thunk';
import WorkStatus from './WorkStatus';

export interface ParamsStatusForBuildingDetail {
  building_id: string;
  date: string;
  cooperator_id?: string;
  site_id?: string;
}
const SiteDetail: FC = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { buildingId, site_id } = useParams<{ buildingId: string; site_id: string }>();
  const { entity = Site.WORK_STATUS } = useParams<{ entity: Site }>();
  const [loading, setLoading] = useState<boolean>(true);
  const [detailOneImage, setDetailOneImage] = useState<number | null>(null);
  const [loadingOneImage, setLoadingOneImage] = useState(true);
  const images = useSelector(imageSelectors.selectAll);

  const { workRisk, image } = useSelector(siteDetailSelector);
  // 2025/02/12 FJ 3月分反映分 NO58 start
  // const { roleUser } = useSelector(userData);
  // 2025/02/12 FJ 3月分反映分 NO58 end
  const { siteGroupsWorkers } = useSelector(businessDetailSelector);
  // 2025/02/12 FJ 3月分反映分 NO58 start
  const { user_id, roleUser } = useSelector(userData);
  // 2025/02/12 FJ 3月分反映分 NO58 end

  const getStatusForBuildingDetail = useCallback(
    (params: ParamsStatusForBuildingDetail) => {
      dispatch(getLockStatus({ building_id: params.building_id, date: params.date }));
      dispatch(
        getKYDataApproveGroupBySiteManage({
          building_id: params.building_id,
          date: params.date,
          first_cooperator_code: String(params.cooperator_id ?? ''),
        })
      );
      if (roleUser !== userRole.BO) {
        dispatch(getStatusKy(params));
      }
    },
    [dispatch, roleUser]
  );

  const fetchAPI = useCallback(() => {
    switch (entity) {
      case Site.ALBUMS:
        getStatusForBuildingDetail({
          building_id: buildingId,
          date: dayjs(new Date()).format('YYYY-MM-DD'),
        });

        dispatch(getAlbumsImage({ building_id: buildingId }));
        detailOneImage && dispatch(getDetailImage({ image_id: detailOneImage }));
        break;
      case Site.WORK_STATUS:
        break;
      case Site.WORK_INFO:
        getStatusForBuildingDetail({
          building_id: buildingId,
          date: dayjs(new Date()).format('YYYY-MM-DD'),
        });
        // 2024/01/02 Leading Win 教育機能対応 DXWEBWIN00100_作業員情報 start
        // dispatch(getWorkersChargeSiteList({ building_id: +buildingId }));
        // dispatch(getSiteUserSchedules({ building_id: +buildingId }));
        // 2025/02/11 FJ 3月分反映分 NO58 start
        dispatch(
          getSiteGroupsWorkers({
            building_id: buildingId,
            user_id: `${user_id}`,
            // 2025/02/12 FJ 3月分反映分 NO58 start
            role: Number(roleUser),
            // 2025/02/12 FJ 3月分反映分 NO58 end
          })
        );
        // 2025/02/11 FJ 3月分反映分 NO58 end
        // 2024/01/02 Leading Win 教育機能対応 DXWEBWIN00100_作業員情報 end
        break;
    }
    // 2025/02/11 FJ 3月分反映分 NO58 start
  }, [buildingId, detailOneImage, dispatch, entity, getStatusForBuildingDetail, user_id, roleUser]);
  // 2025/02/11 FJ 3月分反映分 NO58 end

  useEffect(() => {
    (async () => {
      await fetchAPI();

      setLoading(false);
    })();
  }, [fetchAPI]);

  const handleSelectedTab = useCallback(
    (entity) => {
      return history.replace(generatePath(routes.SiteDetail.path, { entity, buildingId, site_id }));
    },
    [history, buildingId, site_id]
  );

  return (
    <SectionStyled>
      <Layout
        tabs={tabList}
        defaultValue={entity}
        onSelected={handleSelectedTab}
        showNotification={roleUser !== userRole.CM}
        back
        left
        right
      />

      {entity === Site.WORK_STATUS && (
        <WorkStatus
          dataWorkRisk={workRisk.sites}
          loadingWorkRisk={workRisk.loading}
          getStatusForBuildingDetail={getStatusForBuildingDetail}
        />
      )}
      {entity === Site.ALBUMS && roleUser === userRole.DTC && (
        <Albums
          images={images}
          loading={loading}
          detailImage={image}
          setDetailOneImage={setDetailOneImage}
          setLoadingOneImage={setLoadingOneImage}
          loadingOneImage={loadingOneImage}
        />
      )}
      {entity === Site.ALBUMS && roleUser === userRole.CM && (
        <AlbumsCm
          setDetailOneImage={setDetailOneImage}
          imagesCM={images}
          loading={loading}
          detailImage={image}
          setLoadingOneImage={setLoadingOneImage}
          loadingOneImage={loadingOneImage}
        />
      )}
      {/** 2024/01/02 Leading Win 教育機能対応 DXWEBWIN00100_作業員情報 start */}
      {entity === Site.WORK_INFO && roleUser !== userRole.BO && (
        <WorkerInfoSite data={siteGroupsWorkers.users || []} />
      )}
      {/** 2024/01/02 Leading Win 教育機能対応 DXWEBWIN00100_作業員情報 end */}
    </SectionStyled>
  );
};

const tabList: LayoutProps['tabs'] = [
  // 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 start
  //  { label: '作業状況', key: Site.WORK_STATUS },
  { label: '作業日報', key: Site.WORK_STATUS },
  // 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 end
  { label: '写真管理', key: Site.ALBUMS },
  { label: '作業員情報', key: Site.WORK_INFO },
];

export default SiteDetail;
